const SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/u;

export type ExhibitionSelection =
  | { kind: "menu" }
  | { kind: "exhibition"; slug: string }
  | { kind: "invalid" };

export function readExhibitionSelection(search = window.location.search): ExhibitionSelection {
  const parameters = new URLSearchParams(search);
  const values = parameters.getAll("exhibition");
  if (values.length === 0) return { kind: "menu" };
  const slug = values[0];
  if (values.length !== 1 || slug === undefined || slug.length > 64 || !SLUG.test(slug)) {
    return { kind: "invalid" };
  }
  return { kind: "exhibition", slug };
}

export function selectionUrl(slug: string | null, current = window.location.href): string {
  const url = new URL(current);
  url.searchParams.delete("exhibition");
  if (slug !== null) url.searchParams.set("exhibition", slug);
  url.hash = "";
  return `${url.pathname}${url.search}`;
}
